<script setup>

</script>

<template>
    <svg class="w-6 h-6" focusable="false" viewBox="0 0 24 24" aria-hidden="true"><path d="M7 10l5 5 5-5z"></path></svg>
</template>

<style scoped>

</style>